import React from "react";
import { List, ListItem } from "@mui/material";
import RenderSvg from "../../renderSvg/RenderSvg";
import CloseIcon from '@mui/icons-material/Close';
import { formatDecimal } from "../../../components/dms_common/DmsUtils";

interface DisplayVisibilityFormSideMenuProps {
    data: any[];
    onEdit: (item: any) => void;
    onRemove: (id: string) => void;
    currencySymbol: string;
}

const DisplayVisibilityFormSideMenu: React.FC<DisplayVisibilityFormSideMenuProps> = ({ data, onEdit, onRemove, currencySymbol}) => {

    return (
        <List sx={{
            width: "100%",
            border: '1px solid #EBEBEB',
            borderRadius: 2,
            padding: "0px 0px 4px 0px",
            height: '100%',
            overflowY: "auto",
            display: 'flex',
            flexDirection: 'column'
        }}>
            <div style={{ backgroundColor: "#F0FBFF", height: "40px", display: "flex", alignItems: "center", justifyContent: "start", flexShrink: 0 }}>
                <span style={{ fontSize: "0.9rem", fontWeight: 500, paddingLeft: "6px", color: "#227C9D" }}>Raised Asset Claims</span>
            </div>
            <div style={{ flex: 1, overflowY: 'auto' }}>
                {data.map((item, index) => (
                    <ListItem
                        key={index}
                        sx={{
                            backgroundColor: "#fff",
                            padding: "6px",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            borderBottom: "0.5px solid #CECECE",
                            paddingX: "10px",
                            display: "flex",
                            gap: "5px",
                        }}
                    >
                        <div style={{
                            flex: 1,
                            minWidth: 0,
                            display: "flex",
                            flexDirection: "column",
                            overflowWrap: "break-word",
                            wordWrap: "break-word",
                        }}>
                            <span style={{ fontSize: "0.8rem", fontWeight: 500 }}>{item.outletName}</span>
                            <span style={{ fontSize: "0.6rem" }}>{item.skuCode}</span>
                            <span style={{ fontSize: "0.8rem", fontWeight: 500 }}>{currencySymbol} {formatDecimal(item.totalClaimAmount)}</span>
                        </div>

                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            flexShrink: 0,
                        }}>
                            <div
                                style={{
                                    color: "#227C9D",
                                    height: "17px",
                                    cursor: "pointer",
                                    flexShrink: 0,
                                }}
                                onClick={() => onEdit(item)}
                            >
                                <RenderSvg name="viewAndEditIcon" />
                            </div>

                            <CloseIcon
                                sx={{
                                    color: "#227C9D",
                                    fontSize: "1.2rem",
                                    cursor: "pointer",
                                    flexShrink: 0,
                                }}
                                onClick={() => onRemove(item.id)}
                            />
                        </div>
                    </ListItem>
                ))}
            </div>
        </List>
    );
};
export default DisplayVisibilityFormSideMenu;
